(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swift-mobile-home"] && !Shopify.designMode) return;
  try {
    (()=>{
    function revealMobileSection(){
      if(!window.matchMedia('(max-width:749px)').matches)return;
      const target=document.getElementById(location.hash.slice(1));
      if(target?.matches('.swift-mobile-details details'))target.open=true;
      if((location.hash==='#quote'||location.hash==='#SwiftProjectEnquiry')&&document.querySelector('.swift-mobile-home')){
        location.replace('/pages/contact#SwiftProjectEnquiry');
      }
    }
    window.addEventListener('hashchange',revealMobileSection);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',revealMobileSection,{once:true});else revealMobileSection();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swift-mobile-navigation"] && !Shopify.designMode) return;
  try {
    (()=>{
    function initialiseSwiftMenu(){
      const dialog=document.getElementById('SwiftMobileMenu');
      const trigger=document.querySelector('.swift-mobile-menu-toggle');
      if(!dialog||!trigger||trigger.dataset.swiftBound)return;
      trigger.dataset.swiftBound='true';
      function closeMenu(){if(dialog.open)dialog.close();}
      trigger.addEventListener('click',()=>{dialog.showModal();trigger.setAttribute('aria-expanded','true');document.documentElement.classList.add('swift-menu-open');});
      dialog.querySelector('.swift-mobile-menu-close').addEventListener('click',closeMenu);
      dialog.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');document.documentElement.classList.remove('swift-menu-open');});
      dialog.addEventListener('click',event=>{if(event.target.closest('a'))closeMenu();});
      const media=window.matchMedia('(max-width:749px)');
      media.addEventListener('change',()=>{if(!media.matches)closeMenu();});
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseSwiftMenu,{once:true});else initialiseSwiftMenu();
    document.addEventListener('shopify:section:load',initialiseSwiftMenu);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swift-project-portfolio"] && !Shopify.designMode) return;
  try {
    (function () {
  function initialisePortfolioCarousels() {
    document.querySelectorAll('.swift-portfolio-category').forEach(function (category) {
      var track = category.querySelector('.swift-portfolio-grid');
      var controls = category.querySelector('.swift-portfolio-controls');
      if (!track || !controls || track.dataset.carouselReady === 'true') return;

      var previous = controls.querySelector('[data-direction="-1"]');
      var next = controls.querySelector('[data-direction="1"]');
      var frame;

      function updateButtons() {
        var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maximum - 4;
      }

      function move(direction) {
        var distance = Math.max(360, Math.round(track.clientWidth * 0.78));
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateButtons);
      }, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });

      if ('ResizeObserver' in window) new ResizeObserver(updateButtons).observe(track);
      window.addEventListener('resize', updateButtons, { passive: true });
      track.dataset.carouselReady = 'true';
      updateButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePortfolioCarousels, { once: true });
  } else {
    initialisePortfolioCarousels();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swift-service-quote"] && !Shopify.designMode) return;
  try {
    (() => {
    const serviceByHandle = {
      'tarmac-driveways-blackpool': 'Tarmac driveway',
      'resin-bound-driveways-blackpool': 'Resin-bound driveway',
      'commercial-surfacing-blackpool': 'Car park or commercial surfacing',
      'commercial-services': 'Car park or commercial surfacing',
      'resurfacing-blackpool': 'Repairs and resurfacing',
      'civil-engineering-blackpool': 'Civil engineering',
      'road-surfacing-blackpool': 'Road surfacing',
      'utility-reinstatement-blackpool': 'Utility reinstatement',
      'surfacing-crews-operated-plant': 'Paver or surfacing crew services',
      'dropped-kerbs-blackpool': 'Dropped kerbs'
    };
    function initialiseServiceQuotes() {
      const handle = location.pathname.split('/').filter(Boolean).pop();
      const service = serviceByHandle[handle];
      if (service) {
        document.querySelectorAll('a[href]').forEach(link => {
          const url = new URL(link.getAttribute('href'), location.origin);
          if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === '/pages/contact' && !url.searchParams.has('service')) {
            url.searchParams.set('service', service);
            url.hash = 'SwiftProjectEnquiry';
            link.href = url.pathname + url.search + url.hash;
          }
        });
      }
      if (document.getElementById('SwiftProjectEnquiry')) {
        document.querySelectorAll('a[href]').forEach(link => {
          const url = new URL(link.getAttribute('href'), location.origin);
          if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === '/pages/contact') {
            if (link.closest('nav') || link.closest('footer') || link.closest('.swift-mobile-contact') || link.hasAttribute('data-swift-mobile-route')) return;
            link.href = '#SwiftProjectEnquiry';
          }
        });
      }
      const selectedService = new URLSearchParams(location.search).get('service');
      document.querySelectorAll('select[name="contact[Service]"]').forEach(select => {
        if (selectedService && Array.from(select.options).some(option => option.value === selectedService)) {
          select.value = selectedService;
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseServiceQuotes, { once: true });
    } else {
      initialiseServiceQuotes();
    }
    document.addEventListener('shopify:section:load', initialiseServiceQuotes);
  })();
  } catch(e) { console.error(e); }
})();

})();
